import i18next from 'i18next';
import { useSyncExternalStore } from 'react';

import { getScriptVersion, onScriptLoaded } from './script';

function subscribe(onChange: () => void): () => void {
  i18next.on('languageChanged', onChange);
  const offScript = onScriptLoaded(onChange);
  return () => {
    i18next.off('languageChanged', onChange);
    offScript();
  };
}

// Language plus converter version, so a component re-renders both when the
// language changes and when its script converter finishes loading.
const snapshot = () => `${i18next.language ?? 'en'}\u0000${getScriptVersion()}`;

/**
 * The current site language, which is also the user's language preference in
 * the host and admin backend (PRD §5.6). English until i18n initializes.
 */
export function useSiteLanguage(): string {
  return useSyncExternalStore(subscribe, snapshot).split('\u0000')[0] || 'en';
}
